export const isProperPassword = value => /^((?=.*?[A-z])(?=.*?[0-9])(?!.*?[ㄱ-ㅎ|ㅏ-ㅣ|가-힣])).{8,20}$/.test(value);
